import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { trackError } from 'utils/helpers';
import { discardBooking, replaceBooking } from 'redux/actions/booking';

export const useCleanup = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const onReceiptPage = useRef(false);
  useEffect(() => {
    if (
      onReceiptPage.current &&
      !pathname?.includes('/bookings/checkout/receipt')
    ) {
      // Leave from Receipt page
      dispatch(replaceBooking({}));
      dispatch(discardBooking({ clearFerryGrouping: true })).catch((error) => {
        trackError(error);
      });
    }
    return () => {
      onReceiptPage.current = pathname?.includes('/bookings/checkout/receipt');
    };
  }, [dispatch, pathname]);
};
